import { CourseModuleFrame } from '@/components/courses/CourseModuleFrame';
import { Quiz } from '@/components/quiz/Quiz';
import React from 'react';

type CourseQuizModuleProps = React.ComponentProps<typeof Quiz> & {
  accessibilityIcon?: React.ReactNode;
};

export const CourseQuizModule: React.FC<CourseQuizModuleProps> = ({
  accessibilityIcon,
  ...quizProps
}) => (
  <CourseModuleFrame>
    {accessibilityIcon}
    <Quiz {...quizProps} />
  </CourseModuleFrame>
);
